import { compact } from '@lglp/utils';
import { map, prop } from 'ramda';

import { eq } from '../../../../helpers/compact';
import { getColorScale, getLegends, getPies, multiple } from './charts';

const getChart = (data) => {
  const _multiple = multiple(data);
  const _style = {
    fontFamily: "'Montserrat', sans-serif",
  };

  return compact({
    title: prop('title', prop('primary', data)),
    desc: prop('desc', prop('primary', data)),
    year: prop('year', prop('primary', data)),
    colorScale: getColorScale(data),
    pies: getPies(data),
    legends: getLegends(data),
    linebreak: eq('linebreak', 'oui', false, prop('primary', data)),
    style: {
      data: {
        strokeWidth: 0,
      },
      labels: _multiple
        ? {
            ..._style,
            fill: '#333333',
            fontSize: 13,
            padding: 5,
          }
        : {
            ..._style,
            fontSize: 20,
            fontWeight: 700,
            fill: '#00146a',
          },
    },
    labelY: _multiple ? null : 175,
  });
};

export const processPieChart = (data = []) => compact(map(getChart, data));
